import { render, staticRenderFns } from "./form-service.vue?vue&type=template&id=12a7e133&scoped=true"
import script from "./form-service.vue?vue&type=script&lang=js"
export * from "./form-service.vue?vue&type=script&lang=js"
import style0 from "./form-service.vue?vue&type=style&index=0&id=12a7e133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7e133",
  null
  
)

export default component.exports